import { FC } from "react";

interface ErrorContainerProps {
  touched: boolean | string | undefined;
  error: string | undefined | string[];
}

const ErrorContainer: FC<ErrorContainerProps> = (props: ErrorContainerProps) => {
  const { touched, error } = props;
  return <>{touched && error
    ? <span className='text-xs font-thin text-red'>
      {error}
    </span>
    : <></>}
  </>;
};

export default ErrorContainer;
